import { Dropdown as AntDropdown } from 'antd'
import type { ComponentProps, ReactNode } from 'react'

type AntDropdownProps = ComponentProps<typeof AntDropdown>
type AntDropdownButtonProps = ComponentProps<typeof AntDropdown.Button>
type OverlayProp = ReactNode | (() => ReactNode)

const toPopupRender = (overlay: OverlayProp) => () => <>{typeof overlay === 'function' ? overlay() : overlay}</>

export interface AppDropdownProps extends AntDropdownProps {
  overlay?: OverlayProp
  onVisibleChange?: (open: boolean) => void
}

export const AppDropdown = ({ overlay, onVisibleChange, onOpenChange, popupRender, ...rest }: AppDropdownProps) => (
  <AntDropdown
    onOpenChange={onVisibleChange ?? onOpenChange}
    popupRender={overlay !== undefined ? toPopupRender(overlay) : popupRender}
    {...rest}
  />
)

export interface AppDropdownButtonProps extends AntDropdownButtonProps {
  overlay?: OverlayProp
  onVisibleChange?: (open: boolean) => void
}

export const AppDropdownButton = ({
  overlay,
  onVisibleChange,
  onOpenChange,
  popupRender,
  ...rest
}: AppDropdownButtonProps) => (
  <AntDropdown.Button
    onOpenChange={onVisibleChange ?? onOpenChange}
    popupRender={overlay !== undefined ? toPopupRender(overlay) : popupRender}
    {...rest}
  />
)
